import {
  BRANCHES_LOAD_BRANCHES_PENDING,
  BRANCHES_LOAD_BRANCHES_FULFILLED,
  BRANCHES_LOAD_BRANCHES_REJECTED,
  BRANCHES_LOAD_NEW_BRANCHES_PENDING,
  BRANCHES_LOAD_NEW_BRANCHES_FULFILLED,
  BRANCHES_LOAD_NEW_BRANCHES_REJECTED,
  BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_PENDING,
  BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_FULFILLED,
  BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_REJECTED,
  BRANCHES_POST_BRANCH_PENDING,
  BRANCHES_POST_BRANCH_FULFILLED,
  BRANCHES_POST_BRANCH_REJECTED,
  BRANCHES_PUT_BRANCH_PENDING,
  BRANCHES_PUT_BRANCH_FULFILLED,
  BRANCHES_PUT_BRANCH_REJECTED,
  BRANCHES_PUT_BRANCH_ADMIN_PENDING,
  BRANCHES_PUT_BRANCH_ADMIN_FULFILLED,
  BRANCHES_PUT_BRANCH_ADMIN_REJECTED,
  BRANCHES_DELETE_BRANCH_PENDING,
  BRANCHES_DELETE_BRANCH_FULFILLED,
  BRANCHES_DELETE_BRANCH_REJECTED,
  BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_PENDING,
  BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_FULFILLED,
  BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_REJECTED,
  BRANCHES_CLEAR_BRANCHES_MESSAGES,
} from '../actions/branches'

import i18n from 'i18next'

export default function branches(state = {}, action) {
  switch (action.type) {
    case BRANCHES_LOAD_BRANCHES_PENDING:
    case BRANCHES_LOAD_NEW_BRANCHES_PENDING:
    case BRANCHES_POST_BRANCH_PENDING:
    case BRANCHES_PUT_BRANCH_PENDING:
    case BRANCHES_PUT_BRANCH_ADMIN_PENDING:
    case BRANCHES_DELETE_BRANCH_PENDING:
    case BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_PENDING:
    case BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_PENDING:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        successMessage: null,
      }
    case BRANCHES_LOAD_BRANCHES_REJECTED:
    case BRANCHES_LOAD_NEW_BRANCHES_REJECTED:
    case BRANCHES_POST_BRANCH_REJECTED:
    case BRANCHES_PUT_BRANCH_REJECTED:
    case BRANCHES_PUT_BRANCH_ADMIN_REJECTED:
    case BRANCHES_DELETE_BRANCH_REJECTED:
    case BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_REJECTED:
    case BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_REJECTED:
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${action.payload.response?.data?.code}`, 'error.something_wrong']),
      }
    case BRANCHES_LOAD_BRANCHES_FULFILLED:
      const branches = state?.branches || []
      const newBranchesIds = action.payload.data?.map((item) => item.id)
      const difference = branches.filter((x) => !newBranchesIds.includes(x.id)).concat(action.payload.data)

      return {
        ...state,
        branches: difference,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case BRANCHES_LOAD_NEW_BRANCHES_FULFILLED:
      return {
        ...state,
        branches: action.payload.data,
        canLoadMore: action.payload.nextPage,
        isLoading: false,
      }
    case BRANCHES_LOAD_BRANCHES_BY_COMPANY_ID_FULFILLED:
      return {
        ...state,
        branchesByCompanyId: action.payload.data,
        isLoading: false,
      }
    case BRANCHES_POST_BRANCH_FULFILLED:
      const initialBranches = state?.branches || []

      return {
        ...state,
        branches: [action.payload, ...initialBranches],
        isLoading: false,
        successMessage: i18n.t('organization_context.success_add_branch'),
      }
    case BRANCHES_PUT_BRANCH_FULFILLED:
      const updatedBranches = state?.branches?.map((item) => (item.id === action.payload.id ? { ...action.payload } : item))

      return {
        ...state,
        branches: updatedBranches,
        isLoading: false,
        successMessage: i18n.t('organization_context.success_edit_branch'),
      }
    case BRANCHES_PUT_BRANCH_ADMIN_FULFILLED:
      const updatedBranchesAdmin = state?.branches?.map((item) => (item.id === action.payload.id ? { ...item, email: action.payload.email } : item))
      return {
        ...state,
        branches: updatedBranchesAdmin,
        isLoading: false,
        successMessage: i18n.t('organization_context.branch_admin_updated'),
      }

    case BRANCHES_DELETE_BRANCH_FULFILLED:
      const filteredBranches = state.branches?.filter((branch) => branch.id !== action.meta.branchId) || []
      return {
        ...state,
        branches: filteredBranches,
        isLoading: false,
        successMessage: i18n.t('organization_context.branch_deleted'),
      }
    case BRANCHES_LOAD_BRANCHES_COUNTRY_OPTIONS_FULFILLED:
      return {
        ...state,
        countryOptions: action.payload,
        isLoading: false,
      }
    case BRANCHES_CLEAR_BRANCHES_MESSAGES: {
      return {
        ...state,
        errorMessage: null,
        successMessage: null,
      }
    }
    case 'CLEAR_USER_BRANCHES':
      return {
        ...state,
        branchesByCompanyId: [],
      }
    default:
      return state
  }
}
